import { useCallback } from 'react'
import { useSelector, useDispatch} from 'react-redux'
import { RootState } from '../modules'
import { getArchiveEmail } from '../modules/archiveEmails'


export default function useArchiveEmail() {
  const archiveEmail = useSelector((state:RootState)=>state.archiveEmail.data)
  const dispatch = useDispatch();

  const getArchiveEmails = useCallback(
    (listId: string) => dispatch(getArchiveEmail.request(listId)),
    [dispatch]
  )

  return{
    archiveEmail,
    getArchiveEmails,
  }
}
